import { AST } from '@handlebars/parser';

import { NodeType } from '../../../node/types';

export const isCommentStatement = (statement: AST.Statement): statement is AST.CommentStatement =>
  statement.type === NodeType.CommentStatement;
